import { useMemo, useCallback } from 'react'
import { Combobox, Skeleton } from '@design-systems/canvas-ui'
import { useQuery } from '@apollo/client/react'
import { GET_ROLES } from 'graphql/queries/users/queries/userQueries'

type UsersRolesComboboxProps = {
  onRolesSelect: (roles: any) => void
  value?: any
}

type CanvasComboboxProps = Omit<
  React.ComponentProps<typeof Combobox>,
  'options' | 'onChange' | 'value'
>

const UserRolesCombobox = ({
  onRolesSelect,
  className,
  ...canvasProps
}: UsersRolesComboboxProps & CanvasComboboxProps) => {
  const {
    data: rolesData,
    loading: rolesLoading,
    error: rolesError,
  } = useQuery(GET_ROLES, {
    fetchPolicy: 'cache-and-network',
  })

  const currentRoleOptions = useMemo(
    () =>
      rolesData?.roles?.content.map((role) => ({
        id: role.id,
        value: role.id,
        label: role.name,
      })) || [],
    [rolesData],
  )

  const handleRolesSelect = useCallback(
    (options: any) => {
      onRolesSelect?.(options)
    },
    [onRolesSelect],
  )
  return !rolesLoading && !rolesError ? (
    <Combobox
      options={currentRoleOptions}
      onChange={handleRolesSelect}
      className={className}
      {...canvasProps}
    />
  ) : (
    <Skeleton className={className} />
  )
}

export default UserRolesCombobox
